const NAME = "MY_DESKTOP";

export default NAME;
